import { useCallback, useMemo } from "react"

import { getCatalogItemLayerStyle } from "@l2r-front/l2r-common"
import {
    Layer,
    useOrderingLayers,
    getClusterCountLayerConfig,
    CLUSTER_LAYER_SIZE,
    getClusterLayerConfig,
    CAMPAIGNS_LAYER_CLUSTER,
    CAMPAIGNS_LAYER,
    CAMPAIGNS_LAYER_CLUSTER_COUNT,
    MAX_ZOOM_LEVEL_CLUSTERED,
    CAMPAIGNS_SOURCE,
} from "@l2r-front/l2r-map"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { useTheme } from "@l2r-front/l2r-ui"
import { useNavigateWithSearchParams } from "@l2r-front/l2r-utils"

import { APP_CITY } from "../../../../common/constants/appCity"
import { MODULE_HORIZONTAL_SIGNING } from "../../../../common/constants/modules"

import { HorizontalSigningSource } from "../HorizontalSigningSource"

export function HorizontalSigningCampaignLayer(props) {

    const {
        campaignId,
        campaignFilters,
    } = props

    useOrderingLayers([CAMPAIGNS_LAYER, CAMPAIGNS_LAYER_CLUSTER, CAMPAIGNS_LAYER_CLUSTER_COUNT])
    const navigate = useNavigateWithSearchParams()
    const { selectedNetwork } = useNetworksStateContext()
    const theme = useTheme()

    const horizontalSigningLayerConfig = useMemo(() => {
        return getCatalogItemLayerStyle()
    }, [])

    const handleHorizontalSigningLayerClick = useCallback((event) => {
        const feature = event.feature
        const road = JSON.parse(feature.properties?.linearLocation).road
        if (feature?.properties?.disabled) {
            return
        }
        navigate(encodeURI(`/${selectedNetwork?.slug}/${APP_CITY}/${MODULE_HORIZONTAL_SIGNING}/${road}/${feature.properties?.uuid}`))
    }, [selectedNetwork, navigate])

    const clusterLayerConfig = useMemo(() => {
        if (!theme) {
            return null
        }
        return getClusterLayerConfig({
            paint: {
                "circle-color": theme.palette["common/gray_states"].dark,
                "circle-radius": CLUSTER_LAYER_SIZE,
            },
        })
    }, [theme])

    const handleClusterLayerClick = useCallback((event) => {
        const map = event.target
        const feature = event.feature
        const geometry = feature.geometry
        const clusterId = feature?.properties?.["cluster_id"]
        const source = map.getSource(CAMPAIGNS_SOURCE)
        source.getClusterExpansionZoom(clusterId, (error, zoom) => {
            if (error) {
                return
            }
            map.easeTo({
                center: geometry.coordinates,
                zoom: zoom + 1,
            })
        })
    }, [])

    const clusterCountLayerConfig = useMemo(() => {
        if (!theme) {
            return null
        }
        return getClusterCountLayerConfig({
            layout: {
                "text-size": theme.typography["Desktop & Mobile/Heading/H2"].fontSize,
            },
            paint: {
                "text-color": theme.palette.map.text,
            },
        })
    }, [theme])

    return <HorizontalSigningSource
        id={CAMPAIGNS_SOURCE}
        cluster={true}
        clusterMaxZoom={MAX_ZOOM_LEVEL_CLUSTERED}
        campaignId={campaignId}
        filters={campaignFilters}
    >
        <Layer
            {...horizontalSigningLayerConfig}
            id={CAMPAIGNS_LAYER}
            onClick={handleHorizontalSigningLayerClick}
        />
        <Layer
            {...clusterLayerConfig}
            id={CAMPAIGNS_LAYER_CLUSTER}
            onClick={handleClusterLayerClick}
        />
        <Layer
            {...clusterCountLayerConfig}
            id={CAMPAIGNS_LAYER_CLUSTER_COUNT}
        />
    </HorizontalSigningSource>
}
